<template>
  <v-text-field
    v-model="localValue"
    dense
    single-line
    hide-details
    solo
    flat
    clearable
    placeholder="HH:mm"
    :tabindex="-1"
    ref="input"
    @input="onInput"
    @keydown.enter.stop.prevent="onEnter"
    @keydown.esc.stop.prevent="onCancel"
    @blur="onBlur"
    @click:clear="onClear"
  />
</template>

<script>
export default {
  name: "TimeCellInput",

  props: {
    value: { type: String, default: "" },
    active: Boolean
  },

  data() {
    return {
      localValue: this.value,
      lastValid: this.value,
      dirty: false,
      committing: false,
    };
  },

  watch: {
    value(v) {
      // aceptar cambios propios (post-commit)
      if (this.committing) {
        this.syncValue(v);
        this.committing = false;
        this.dirty = false;
        return;
      }

      // ignorar cambios externos mientras edita
      if (this.dirty) return;

      this.syncValue(v);
    },
  },

  mounted() {
    this.focusInput();
  },

  methods: {
    /* ======================
     * Helpers
     * ====================== */

    syncValue(v) {
      this.localValue = v;
      this.lastValid = v;
    },

    focusInput() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const el = this.$refs.input?.$el.querySelector("input");
          el?.focus();
          el?.select();
        });
      });
    },

    digitsOnly(v) {
      return String(v || "").replace(/\D/g, "");
    },

    /* ======================
     * Events
     * ====================== */

    onCancel() {
      this.$emit("cancel");
    },

    onInput(v) {
      const digits = this.digitsOnly(v);

      if (digits === this.localValue) return;

      this.localValue = digits;
      this.dirty = true;

      this.$emit("input", digits);
    },

    onEnter() {
      const result = this.normalize(this.localValue);

      if (!result.valid) {
        this.$emit("error", result.error);
        this.focusInput();
        return;
      }

      this.commit(result.value);
    },

    onBlur() {
      if (!this.localValue) {
        this.dirty = false;
        return;
      }

      const result = this.normalize(this.localValue);

      if (!result.valid) {
        this.localValue = "";
        this.$emit("input", "");
        this.$emit("error", result.error);

        if (this.active) this.focusInput();
        return;
      }

      this.commit(result.value);
    },

    onClear() {
      this.localValue = "";
      this.dirty = false;

      this.$emit("input", "");
      this.$emit("commit", null);
    },

    commit(value) {
      this.committing = true;

      this.syncValue(value);
      this.dirty = false;

      this.$emit("input", value);
      this.$emit("commit", {
        value,
      });
    },

    /* ======================
     * Normalización HH:mm
     * ====================== */

    normalize(input) {
      if (!input) {
        return { valid: false, error: "Horario vacío" };
      }

      const d = this.digitsOnly(input);
      let hh, mm;

      if (d.length <= 2) {
        hh = parseInt(d, 10);
        mm = 0;
      } else if (d.length === 3) {
        hh = parseInt(d[0], 10);
        mm = parseInt(d.slice(1), 10);
      } else if (d.length === 4) {
        hh = parseInt(d.slice(0, 2), 10);
        mm = parseInt(d.slice(2), 10);
      } else {
        return { valid: false, error: "Formato inválido" };
      }

      if (hh > 23 || mm > 59) {
        return { valid: false, error: "Horario fuera de rango" };
      }

      return {
        valid: true,
        value: `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`,
      };
    },
  },
};
</script>



<!-- <template>
    <v-text-field v-model="localValue" dense single-line hide-details solo flat clearable placeholder="HH:mm"
         :tabindex="-1" ref="input" @input="onInput" @keydown.enter.stop.prevent="onEnter" @keydown.esc.stop.prevent="onCancel" @blur="onCancel"
        @click:clear="onClear"/>
</template>

<script>
export default {
    name: "TimeCellInput",

    props: {
        value: { type: String, default: "" },
        active: Boolean,
        rowId: [String, Number],
    },

    data() {
        return {
            localValue: this.value,
            lastValid: this.value,
            dirty: false,
            committing: false,
        };
    },
    watch: {
        value(v) {
            // aceptar cambios propios (post-commit)
            if (this.committing) {
                this.localValue = v;
                this.lastValid = v;
                this.committing = false;
                this.dirty = false;
                return;
            }
            // ignorar cambios externos mientras edita
            if (this.dirty) return;
            this.localValue = v;
            this.lastValid = v;
        },
    },
    mounted() {
        console.log(this.value);
        this.$nextTick(() => {
            requestAnimationFrame(() => {
                const el = this.$refs.input?.$el.querySelector("input");
                if (el) {
                    el.focus();
                    el.select();
                }
            });
        });
    },
    methods: {
        onCancel(){
            this.$emit("cancel");
        },
        onInput(v) {
            const value = String(v || "");
            const digits = value.replace(/\D/g, "");

            if (digits === this.localValue) return;

            this.localValue = digits;
            this.dirty = true;

            console.log({v, value, digits, localValue:this.localValue});
            this.$emit("input", digits);
        },

        onEnter() {
            const result = this.normalize(this.localValue);
            if (!result.valid) {
                this.$emit("error", result.error);
                this.$nextTick(() => this.$refs.input?.focus());
                return;
            }
            this.commit(result.value);
        },
        onBlur() {
            if (!this.localValue) {
                this.dirty = false;
                return;
            }
            const result = this.normalize(this.localValue);
            if (!result.valid) {
                this.localValue = "";
                this.$emit("input", "");
                this.$emit("error", result.error);
                if (this.active) {
                    this.$nextTick(() => this.$refs.input?.focus());
                }
                return;
            }
            this.commit(
                result.value,
            );
        },
        onClear() {
            this.localValue = "";
            this.dirty = false;

            this.$emit("input", "");
            this.$emit("commit", null);
        },

        commit(value) {
            console.log("comm");
            this.committing = true;

            this.localValue = value;
            this.lastValid = value;
            this.dirty = false;

            this.$emit("input", value);
            this.$emit("commit", {
                rowId: this.rowId,
                value,
            });
        },

        normalize(input) {
            if (!input) {
                return { valid: false, error: "Horario vacío" };
            }

            const d = input.replace(/\D/g, "");
            let hh, mm;

            if (d.length <= 2) {
                hh = parseInt(d, 10);
                mm = 0;
            } else if (d.length === 3) {
                hh = parseInt(d[0], 10);
                mm = parseInt(d.slice(1), 10);
            } else if (d.length === 4) {
                hh = parseInt(d.slice(0, 2), 10);
                mm = parseInt(d.slice(2), 10);
            } else {
                return { valid: false, error: "Formato inválido" };
            }

            if (hh > 23 || mm > 59) {
                return { valid: false, error: "Horario fuera de rango" };
            }

            return {
                valid: true,
                value:
                    String(hh).padStart(2, "0") +
                    ":" +
                    String(mm).padStart(2, "0"),
            };
        },
    },
};
</script>
-->